// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass } from "./Dom";
import { getEvent } from "./Event";
import { WebPageComponent } from "./WebSite.Page.Component";

export class CookieBar extends WebPageComponent {
  constructor(element) {
    super(element);

    this.cookieName = element.dataset.Name;
    this.cookiePath = element.dataset.Path;

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.button = query.getDescendant(WithClass("Button"));

    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.expanded.setStatus(true);
  }

  buttonClicked(event) {
    document.cookie = this.cookieName + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=" + this.cookiePath;
    this.expanded.setStatus(false);
    getEvent(event).stopHandling();
  }

  attachEventHandlers() {
    this.button.onclick = (event) => { this.buttonClicked(getEvent(event)); };
  }
}

interactivityRegistration.register("CookieBar", function (element) { return new CookieBar(element); });
